import React from "react";
import { Box, Typography } from "@mui/material";

const FTE_OPTIONS = [0.5, 1.0];

const FteSelector = ({ value, onChange, disabled, t }) => {
  return (
    <Box>
      <Box
  sx={{
    borderTop: `1px solid ${t.border}`,
    paddingTop: "14px",
    marginTop: "14px",
    marginBottom: "10px",
  }}
>
  <Typography
    sx={{
      fontFamily: "'DM Mono', monospace",
      fontSize: "9px",
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: t.text3,
    }}
  >
    Billed FTE for this position{" "}
    <span style={{ color: "#28B3B4", marginLeft: "3px" }}>*</span>
  </Typography>

  <Typography
    sx={{
      fontFamily: "'Inter', sans-serif",
      fontSize: "10px",
      color: t.text3,
      marginTop: "4px",
      lineHeight: 1.4,
      opacity: 0.75,
    }}
  >
    Select 1 if this position is fully billed, Select 0.5 if this position is
    only partially billed – This has nothing to do with the Allocation to the MAC
  </Typography>
</Box>

      <Box sx={{ display: "flex", gap: "8px", mb: "4px" }}>
        {FTE_OPTIONS.map((opt) => {
          const isActive = value === opt;
          return (
            <Box
              key={opt}
              onClick={() => !disabled && onChange(opt)}
              sx={{
                flex: 1,
                padding: "14px 10px",
                borderRadius: "6px",
                border: `1px solid ${isActive ? t.accent : t.border2}`,
                background: isActive ? `${t.accent}14` : t.surface2,
                cursor: disabled ? "not-allowed" : "pointer",
                textAlign: "center",
                transition: "all 0.15s",
                pointerEvents: disabled ? "none" : "auto",
                "&:hover": {
                  borderColor: disabled ? t.border2 : `${t.accent}88`,
                  background: disabled ? t.surface2 : `${t.accent}0a`,
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "20px",
                  fontWeight: 600,
                  color: isActive ? t.accent : t.text2,
                  letterSpacing: "0.02em",
                  lineHeight: 1,
                }}
              >
                {opt.toFixed(2)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default FteSelector;